import { AllowDeletesType } from './AllowDeletesType';
// import { FindControlColumnsConfigDto } from './FindControlColumnsConfigDto';
import { PrepopulateType } from './PrepopulateType';

export class FindControlBehaviorDto {
  FindControlBehaviorUid: string;
  ExternalId: string;
  Name: string;
  SecurityGroupUid: string | null;
  Id: string;
  ColumnsConfig: string | null;
  MaxRows: number;
  FindTableUid: string | null;
  Prepopulate: PrepopulateType;
  HasSecurity: boolean;
  AllowMaintenance: boolean;
  AllowNew: boolean;
  AllowDelete: AllowDeletesType;
  Notes: string;
  AddInUid: string | null;
  LicenseCode: string;
  Inactive: boolean;
  UserDefined: number;  // 0: System Defined (no mods), 1: User Defined, 2: System Defined (mods)
}
